import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Flame } from "lucide-react";
import api from "@/lib/api";
import DealCard, { DEAL_STYLES } from "@/components/deals/DealCard";

export default function HotDealsStrip({ categoryId, title = "Hot deals", className = "" }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/deals/hot", { params: { category_id: categoryId || undefined, limit: 8 } })
      .then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [categoryId]);
  if (!items || items.length === 0) return null;
  return (
    <section className={className} data-testid="hot-deals-strip">
      <style>{DEAL_STYLES}</style>
      <div className="flex items-end justify-between gap-6 mb-6">
        <div>
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#d97757] inline-flex items-center gap-1.5"><Flame className="h-3.5 w-3.5" /> Limited time</div>
          <h2 className="mt-2 font-display text-2xl md:text-3xl font-semibold text-[#071b22]" data-testid="hot-deals-title">{title}</h2>
        </div>
        <Link to="/deals" className="inline-flex items-center gap-2 text-sm font-medium text-[#165a71] hover:text-[#11485a]" data-testid="hot-deals-see-all">
          See all deals <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="flex gap-5 overflow-x-auto snap-x snap-mandatory pb-4 -mx-1 px-1" data-testid="hot-deals-list">
        {items.map((d, i) => (
          <div key={d.id} className="snap-start shrink-0 w-[280px] sm:w-[300px] flex"><DealCard d={d} i={i} /></div>
        ))}
      </div>
    </section>
  );
}
